/* Shamelessly stolen from https://github.com/Bynder/bynder-platform/blob/master/bynder-frontend/packages/paramount/src/common/components/FileSelector.tsx */

import React from 'react';
import styled from 'styled-components';

const HiddenInput = styled.input`
  display: none !important;
`;

enum FileDropValidationErrors {
  INCORRECT_CONTENT_TYPE,
  MULTIPLE_FILES,
}

interface Props {
  children: React.ReactNode;
  onFilesSelected: (files: File[]) => void;
  multiple?: boolean;
  active?: boolean;
  contentTypes?: string[];
  dragAndDrop?: boolean;
  onFileDropValidationError?: (
    frontendValidationError: FileDropValidationErrors,
    incorrectContentTypes?: string[],
  ) => void;
}

class FileSelector extends React.Component<Props, Record<string, unknown>> {
  uploadInput: HTMLElement;

  onClick = () => {
    if (this.props.active && this.uploadInput) {
      this.uploadInput.click();
    }
  };

  onFilesSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.onFilesSelected(Array.from(event.target.files));
  };

  filterIncorrectContentTypes = (files: File[]): string[] =>
    files
      .map(file => file.type)
      .filter(contentType => !this.props.contentTypes.includes(contentType));

  getAcceptedContentTypes = () =>
    this.props.contentTypes ? this.props.contentTypes.join(',') : '';

  render() {
    return (
      <React.Fragment>
        <div onMouseDown={this.onClick}>{this.props.children}</div>
        <HiddenInput
          data-testid="fileUploadInput"
          type="file"
          accept={this.getAcceptedContentTypes()}
          ref={(element: HTMLInputElement) => {
            this.uploadInput = element;
          }}
          multiple={this.props.multiple}
          onChange={this.onFilesSelected}
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            if (event.target instanceof HTMLInputElement) {
              event.target.value = null;
            }
          }}
        />
      </React.Fragment>
    );
  }
}

export default FileSelector;
